<header class="page-head" role="banner">
  <div class="o-wrapper">
    <nav class="site-nav site-nav--branding" role="navigation">
      <mpp-res-med-label></mpp-res-med-label>
      <mpp-my-air-label></mpp-my-air-label>
    </nav>
  </div>
</header>